/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

/**
 * Variant free-shipping notice: show/hide per variant.metafields.custom.free_shipping_status (JSON flags in DOM).
 * `on:variant:change` does not bubble — listener uses capture. Exposes window.updateVariantFreeShippingBlocks for sticky ATC sync from the form input.
 */
(function variantFreeShippingToggle() {
  function readFlags(sectionId) {
    var el = document.getElementById('variant-free-shipping-flags-' + sectionId);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  function updateBlocks(sectionId, variantId) {
    var blocks = document.querySelectorAll('[data-variant-free-shipping="' + sectionId + '"]');
    if (!blocks.length) return;
    var flags = readFlags(sectionId);
    var idOk = variantId != null && variantId !== '';
    blocks.forEach(function (block) {
      if (!flags || !idOk) {
        block.classList.add('variant-free-shipping--hidden');
        block.setAttribute('aria-hidden', 'true');
        return;
      }
      var show = flags[String(variantId)] === true;
      if (show) {
        block.classList.remove('variant-free-shipping--hidden');
        block.setAttribute('aria-hidden', 'false');
      } else {
        block.classList.add('variant-free-shipping--hidden');
        block.setAttribute('aria-hidden', 'true');
      }
    });
  }

  window.updateVariantFreeShippingBlocks = updateBlocks;

  document.addEventListener(
    'on:variant:change',
    function (e) {
      var picker = e.target;
      if (!picker || !picker.dataset) return;
      var sectionId = picker.dataset.section || picker.dataset.card;
      if (!sectionId) return;
      if (!document.querySelector('[data-variant-free-shipping="' + sectionId + '"]')) return;
      var v = e.detail && e.detail.variant;
      updateBlocks(sectionId, v && v.id != null ? v.id : null);
    },
    true
  );

  function syncAllFreeShippingFromProductForms() {
    document.querySelectorAll('[id^="variant-free-shipping-flags-"]').forEach(function (scriptEl) {
      var prefix = 'variant-free-shipping-flags-';
      if (scriptEl.id.indexOf(prefix) !== 0) return;
      var sectionId = scriptEl.id.slice(prefix.length);
      var form = document.getElementById('product-form-' + sectionId);
      var input = form && form.querySelector('input[name="id"]');
      var vid = input && input.value;
      updateBlocks(sectionId, vid ? vid : null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllFreeShippingFromProductForms);
  } else {
    syncAllFreeShippingFromProductForms();
  }
})();

/** Shopify default single-variant label; show product title instead for humans. */
function isDefaultVariantTitle(title) {
  if (!title || typeof title !== 'string') return false;
  var t = title.trim();
  return t === 'Default Title' || t.toLowerCase() === 'default title';
}

function variantDisplayTitle(variantTitle, productTitleFallback, onlyDefaultVariantProduct) {
  var fallback = productTitleFallback || '';
  if (onlyDefaultVariantProduct || isDefaultVariantTitle(variantTitle)) return fallback;
  return (variantTitle && String(variantTitle)) || fallback;
}

/**
 * In-memory dismiss state per product (clears on full page refresh; resets on new PDP).
 */
var stickyAtcDismissedProductIds =
  window.__stickyAtcDismissedProductIds || (window.__stickyAtcDismissedProductIds = new Set());

/**
 * Sticky add to cart on product pages.
 * Only runs when .product-single__box__block--buy_buttons and the product form exist.
 * Shows the sticky bar once the user scrolls past the buy buttons block.
 */
(function stickyAddToCart() {
  const buyButtonsBlock = document.querySelector('.product-single__box__block--buy_buttons');
  const stickyBar = document.getElementById('sticky-add-to-cart');

  if (!buyButtonsBlock) {
    console.log('[Sticky ATC] Not initializing: .product-single__box__block--buy_buttons not found');
    return;
  }
  if (!stickyBar) {
    console.log('[Sticky ATC] Not initializing: #sticky-add-to-cart not found');
    return;
  }

  const productForm = buyButtonsBlock.querySelector('form.js-product-form') || buyButtonsBlock.querySelector('form');
  if (!productForm) {
    console.log('[Sticky ATC] Not initializing: no form found inside buy_buttons block');
    return;
  }

  const formId = productForm.id;
  if (!formId) {
    console.log('[Sticky ATC] Not initializing: form has no id');
    return;
  }

  const sectionId = stickyBar.getAttribute('data-section-id');
  const variantPicker = sectionId
    ? document.querySelector('variant-radios[data-section="' + sectionId + '"], variant-selects[data-section="' + sectionId + '"]')
    : null;

  const stickyBtn = stickyBar.querySelector('.js-sticky-add-to-cart-btn');
  const stickyTextEl = stickyBar.querySelector('.js-sticky-add-text');
  const primaryAddBtn = buyButtonsBlock.querySelector('.js-product-add');
  const idInput = productForm.querySelector('input[name="id"]');
  if (!stickyBtn || !primaryAddBtn || !idInput) return;

  const productId = stickyBar.getAttribute('data-product-id');
  const stickyCloseBtn = stickyBar.querySelector('.js-sticky-add-to-cart-close');
  const stickyImg = stickyBar.querySelector('.js-sticky-product-image');
  const stickyName = stickyBar.querySelector('.js-sticky-variant-name');
  const stickyPrice = stickyBar.querySelector('.js-sticky-price');
  const stickyInner = stickyBar.querySelector('.sticky-add-to-cart__inner');
  let ticking = false;
  let lastVisible = null;
  var hideFallbackTimer = null;
  var STICKY_SLIDE_MS = 450;
  var DESKTOP_STICKY_MQ = window.matchMedia('(min-width: 769px)');

  function isStickyDismissed() {
    return productId && stickyAtcDismissedProductIds.has(String(productId));
  }

  function dismissStickyBar() {
    if (!productId || !DESKTOP_STICKY_MQ.matches) return;
    stickyAtcDismissedProductIds.add(String(productId));
    lastVisible = null;
    hideStickyBar();
  }

  function showStickyBar() {
    if (isStickyDismissed()) return;
    if (hideFallbackTimer) {
      clearTimeout(hideFallbackTimer);
      hideFallbackTimer = null;
    }
    stickyBar.classList.add('is-active');
    stickyBar.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        stickyBar.classList.add('is-visible');
      });
    });
  }

  function hideStickyBar() {
    stickyBar.classList.remove('is-visible');
    stickyBar.setAttribute('aria-hidden', 'true');
    if (hideFallbackTimer) clearTimeout(hideFallbackTimer);
    hideFallbackTimer = setTimeout(function () {
      if (!stickyBar.classList.contains('is-visible')) {
        stickyBar.classList.remove('is-active');
      }
      hideFallbackTimer = null;
    }, STICKY_SLIDE_MS);
  }

  if (stickyInner && !stickyBar.dataset.slideBound) {
    stickyBar.dataset.slideBound = '1';
    stickyInner.addEventListener('transitionend', function (e) {
      if (e.target !== stickyInner || e.propertyName !== 'transform') return;
      if (!stickyBar.classList.contains('is-visible')) {
        if (hideFallbackTimer) {
          clearTimeout(hideFallbackTimer);
          hideFallbackTimer = null;
        }
        stickyBar.classList.remove('is-active');
      }
    });
  }

  function getVariantData() {
    if (!variantPicker) return [];
    const script = variantPicker.querySelector('[type="application/json"]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  function getStickyPriceLabel() {
    var mainPrice = sectionId && document.getElementById('price-' + sectionId);
    if (!mainPrice) return '';
    var moneyEl = mainPrice.querySelector('.price__number--sale .money, .price__number .money, .money');
    return moneyEl ? moneyEl.textContent.trim() : '';
  }

  function updateStickyButtonLabel(actionText) {
    if (!stickyTextEl) return;
    var label = actionText || '';
    if (window.matchMedia('(max-width: 768px)').matches && !stickyBtn.disabled) {
      var priceLabel = getStickyPriceLabel();
      stickyTextEl.textContent = priceLabel ? label + ' · ' + priceLabel : label;
    } else {
      stickyTextEl.textContent = label;
    }
  }

  function syncStickyFromPrimary() {
    var textEl = primaryAddBtn.querySelector('.staged-action__text, .js-product-add-text');
    var actionText = textEl ? textEl.textContent.trim() : '';
    stickyBtn.disabled = primaryAddBtn.disabled;

    var currentId = idInput.value;
    if (typeof window.updateVariantFreeShippingBlocks === 'function') {
      window.updateVariantFreeShippingBlocks(sectionId, currentId ? currentId : null);
    }

    var variants = getVariantData();
    var currentVariant = variants.find(function (v) { return String(v.id) === String(currentId); });

    if (currentVariant) {
      var productTitleFallback = stickyBar.getAttribute('data-product-title') || '';
      var productFeaturedSrc = stickyBar.getAttribute('data-product-featured-src') || '';
      var onlyDefaultVariant = stickyBar.getAttribute('data-only-default-variant') === 'true';

      if (stickyName) {
        var displayTitle = variantDisplayTitle(currentVariant.title, productTitleFallback, onlyDefaultVariant);
        stickyName.textContent = displayTitle;
        stickyName.setAttribute('title', displayTitle);
      }
      if (stickyImg) {
        var url = currentVariant.featured_image
          ? currentVariant.featured_image.src || currentVariant.featured_image.url
          : '';
        if (!url) url = productFeaturedSrc;
        if (url) stickyImg.src = url;
        stickyImg.alt = variantDisplayTitle(currentVariant.title, productTitleFallback, onlyDefaultVariant);
      }
    }

    var mainPrice = sectionId && document.getElementById('price-' + sectionId);
    if (stickyPrice && mainPrice && mainPrice.innerHTML) {
      stickyPrice.innerHTML = mainPrice.innerHTML;
    }
    updateStickyButtonLabel(actionText);
  }

  var stickyStagedAction = stickyBtn.querySelector('staged-action');
  var primaryStagedAction = primaryAddBtn.querySelector('staged-action');
  var stickySubmitInProgress = false;
  var observer = null;

  function mirrorPrimaryStagedActionToSticky() {
    if (!stickyStagedAction || !primaryStagedAction) return;
    if (primaryStagedAction.classList.contains('is-done')) {
      stickySubmitInProgress = false;
      stickyStagedAction.setState('DONE');
    } else if (primaryStagedAction.classList.contains('is-doing')) {
      stickyStagedAction.setState('DOING');
    } else if (stickySubmitInProgress) {
      stickySubmitInProgress = false;
      stickyStagedAction.setState('IDLE');
    }
  }

  function checkHasConfirmation() {
    var modalId = 'add-to-cart-confirmation-modal-' + sectionId;
    var m = document.getElementById(modalId);
    var msg = m ? m.getAttribute('data-confirmation-message') : null;
    return !!(m && msg && msg.trim().length > 0);
  }
  document.addEventListener('add-to-cart-confirmation-opened', function () {
    if (!checkHasConfirmation()) return;
    stickySubmitInProgress = true;
    if (stickyStagedAction) stickyStagedAction.setState('DOING');
    if (primaryStagedAction && !observer) {
      observer = new MutationObserver(mirrorPrimaryStagedActionToSticky);
      observer.observe(primaryStagedAction, { attributes: true, attributeFilter: ['class'] });
    }
  });

  document.addEventListener('add-to-cart-confirmation-dismissed', function (ev) {
    var sid = ev.detail && ev.detail.sectionId;
    if (sid !== sectionId) return;
    stickySubmitInProgress = false;
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (stickyStagedAction && typeof stickyStagedAction.setState === 'function') stickyStagedAction.setState('IDLE');
    if (primaryStagedAction && typeof primaryStagedAction.setState === 'function') primaryStagedAction.setState('IDLE');
  });

  stickyBtn.addEventListener('click', function (e) {
    e.preventDefault();
    var needsConfirmation = checkHasConfirmation();
    if (stickyBtn.disabled) return;
    if (needsConfirmation) {
      document.dispatchEvent(new CustomEvent('open-add-to-cart-confirmation', { detail: { sectionId: sectionId } }));
      return;
    }
    if (stickyStagedAction) {
      stickySubmitInProgress = true;
      stickyStagedAction.setState('DOING');
    }
    if (primaryStagedAction && !observer) {
      observer = new MutationObserver(function () {
        mirrorPrimaryStagedActionToSticky();
      });
      observer.observe(primaryStagedAction, { attributes: true, attributeFilter: ['class'] });
    }
    primaryAddBtn.click();
  });

  if (primaryStagedAction && stickyStagedAction) {
    document.addEventListener(
      'on:variant:change',
      function () {
        if (!stickySubmitInProgress) return;
        if (!primaryStagedAction.classList.contains('is-doing') && !primaryStagedAction.classList.contains('is-done')) {
          mirrorPrimaryStagedActionToSticky();
        }
      },
      true
    );
  }

  function updateVisibility() {
    if (isStickyDismissed()) {
      if (stickyBar.classList.contains('is-active')) {
        hideStickyBar();
      }
      return;
    }
    var rect = buyButtonsBlock.getBoundingClientRect();
    var pastThreshold = rect.bottom < 0;
    if (lastVisible === pastThreshold) return;
    lastVisible = pastThreshold;
    if (pastThreshold) {
      showStickyBar();
    } else {
      hideStickyBar();
    }
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(function () {
        updateVisibility();
        ticking = false;
      });
      ticking = true;
    }
  }

  syncStickyFromPrimary();
  updateVisibility();

  if (stickyCloseBtn) {
    stickyCloseBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      dismissStickyBar();
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.matchMedia('(max-width: 768px)').addEventListener('change', syncStickyFromPrimary);
  document.addEventListener('on:variant:change', syncStickyFromPrimary, true);

  var primaryForm = primaryAddBtn.closest('form');
  if (primaryForm) {
    primaryForm.addEventListener('change', function () {
      requestAnimationFrame(syncStickyFromPrimary);
    });
  }
})();

/**
 * Add-to-cart confirmation popup (sticky ATC only).
 * Only opens when the user clicks the sticky Add to Cart and this template has the confirmation/checkbox.
 * Modal is found by section id: add-to-cart-confirmation-modal-{section.id}
 */
document.addEventListener('open-add-to-cart-confirmation', function (e) {
  var sectionId = e.detail && e.detail.sectionId;
  if (!sectionId) return;
  var modal = document.getElementById('add-to-cart-confirmation-modal-' + sectionId);
  if (!modal) return;
  var message = modal.getAttribute('data-confirmation-message');
  if (!message || !message.trim()) return;
  var section = modal.closest('section');
  if (!section) return;
  var form = section.querySelector('form.js-product-form') || section.querySelector('form[action*="/cart/add"]');
  var submitBtn = form && form.querySelector('[name="add"]');
  if (!form || !submitBtn || typeof form.requestSubmit !== 'function') return;

  var messageEl = modal.querySelector('.add-to-cart-confirmation__message');
  var titleEl = modal.querySelector('.add-to-cart-confirmation__title');
  var productImg = modal.querySelector('.add-to-cart-confirmation__product-img');
  var productNameEl = modal.querySelector('.add-to-cart-confirmation__product-name');
  var productSkuEl = modal.querySelector('.add-to-cart-confirmation__product-sku');
  var productBlock = modal.querySelector('.add-to-cart-confirmation__product');

  var variantPicker = document.querySelector('variant-radios[data-section="' + sectionId + '"], variant-selects[data-section="' + sectionId + '"]');
  function getVariantData() {
    if (!variantPicker) return [];
    var script = variantPicker.querySelector('[type="application/json"]');
    if (!script) return [];
    try { return JSON.parse(script.textContent); } catch (err) { return []; }
  }
  function getCurrentVariant() {
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return null;
    var variants = getVariantData();
    return variants.find(function (v) { return String(v.id) === String(idInput.value); }) || null;
  }

  function closeModal(options) {
    var proceed = options && options.proceed === true;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('hidden', '');
    if (!proceed) {
      document.dispatchEvent(
        new CustomEvent('add-to-cart-confirmation-dismissed', { detail: { sectionId: sectionId } })
      );
    }
  }

  function openModal() {
    var heading = modal.getAttribute('data-confirmation-heading') || 'Confirm';
    var productTitleFallback = modal.getAttribute('data-product-title') || '';
    var productFeaturedSrc = modal.getAttribute('data-product-featured-src') || '';
    var onlyDefaultVariant = modal.getAttribute('data-only-default-variant') === 'true';
    if (titleEl) titleEl.textContent = heading;
    if (messageEl) messageEl.textContent = message.trim();
    var variant = getCurrentVariant();
    if (productBlock) {
      var hasPreview =
        variant ||
        productTitleFallback ||
        productFeaturedSrc;
      if (hasPreview) {
        productBlock.style.display = '';
        var lineName = variant
          ? variantDisplayTitle(variant.title, productTitleFallback, onlyDefaultVariant)
          : productTitleFallback;
        if (productImg) {
          var url =
            variant && variant.featured_image
              ? variant.featured_image.src || variant.featured_image.url
              : '';
          if (!url) url = productFeaturedSrc;
          if (url) {
            productImg.src = url;
            productImg.alt = lineName || productTitleFallback;
            productImg.style.display = '';
          } else {
            productImg.style.display = 'none';
          }
        }
        if (productNameEl) {
          if (!lineName || lineName === productTitleFallback) {
            productNameEl.textContent = '';
            productNameEl.style.display = 'none';
          } else {
            productNameEl.textContent = lineName;
            productNameEl.style.display = '';
          }
        }
        if (productSkuEl) {
          if (variant && variant.sku) {
            var skuLabel = section.querySelector('[data-sku-label]');
            productSkuEl.textContent = (skuLabel ? skuLabel.getAttribute('data-sku-label') + ': ' : 'Part #: ') + variant.sku;
            productSkuEl.style.display = '';
          } else {
            productSkuEl.style.display = 'none';
          }
        }
      } else {
        productBlock.style.display = 'none';
      }
    }
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.dispatchEvent(new CustomEvent('add-to-cart-confirmation-opened'));
  }

  function onConfirmProceed() {
    closeModal({ proceed: true });
    // Confirmation checkboxes live in section, often outside the form (pdp-blocks). Check them so "Yes" is sent.
    var confirmationCheckboxes = section.querySelectorAll('input[type="checkbox"].product-form__line-item-checkbox-input');
    confirmationCheckboxes.forEach(function (cb) { cb.checked = true; });
    // Bypass HTML5 validation so the form submits without scrolling to checkbox or blocking
    var wasNoValidate = form.noValidate;
    form.noValidate = true;
    form.requestSubmit(submitBtn);
    if (!wasNoValidate) form.noValidate = false;
  }

  function onChangeSelection() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    closeModal();
  }

  if (!modal.hasAttribute('data-confirmation-bound')) {
    modal.setAttribute('data-confirmation-bound', '1');
    modal.querySelectorAll('[data-close-confirmation]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    var changeSelectionBtn = modal.querySelector('[data-change-selection]');
    if (changeSelectionBtn) changeSelectionBtn.addEventListener('click', onChangeSelection);
    modal.querySelector('[data-proceed-add-to-cart]').addEventListener('click', onConfirmProceed);
    modal.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') closeModal();
    });
  }
  openModal();
});

// Insert any custom theme js here...
(function () {
    const HASH = '#home-custom-collection';
    const SELECTOR = '#home-custom-collection';
    const HEADER_SELECTOR = '.header'; // adjust if needed
    const BUFFER = 20; // extra breathing room
  
    if (location.hash !== HASH) return;
  
    // 1) Prevent the browser’s native anchor jump
    const urlNoHash = location.pathname + location.search;
    history.replaceState(null, '', urlNoHash);
  
    function getHeaderHeight() {
      const header = document.querySelector(HEADER_SELECTOR);
      return header ? header.getBoundingClientRect().height : 0;
    }
  
    function getTargetTop(el) {
      return el.getBoundingClientRect().top + window.scrollY;
    }
  
    function scrollWithOffset(el, smooth = true) {
      const finalTop = Math.max(0, getTargetTop(el) - getHeaderHeight() - BUFFER);
      window.scrollTo({ top: finalTop, behavior: smooth ? 'smooth' : 'auto' });
    }
  
    window.addEventListener('load', () => {
      const target = document.querySelector(SELECTOR);
      if (!target) return;
  
      // 2) Do the main smooth scroll
      scrollWithOffset(target, true);
  
      // 3) Final correction after scrolling finishes (handles late header/font changes)
      const correct = () => {
        scrollWithOffset(target, false);     // snap exactly to the computed spot
        history.pushState(null, '', HASH);   // restore the hash without triggering a jump
      };
  
      if ('onscrollend' in window) {
        window.addEventListener('scrollend', correct, { once: true });
      } else {
        // Fallback timeout roughly matching smooth scroll duration
        setTimeout(correct, 0);
      }
    }, { once: true });
  })();
  